@if (loadFailed) {
<div class="failedSearch">
    <div class="forge-typography--heading2">
        {{loadFailedMessage}}
    </div>
</div>
}

<forge-card class="no-padding" [style]="cardStyles">
    <igx-grid #grid igxPreventDocumentScroll filterMode="excelStyleFilter" primaryKey="Id"
        [allowFiltering]="useColumnFiltering" [cellSelection]="cellSelectionMode" [data]="gridDataObservable | async"
        [filterStrategy]="filterStrategy" [hideRowSelectors]="!enableMultiSelect" [id]="providerId"
        [igxGridState]="options" [isLoading]="isFetching" [rowSelection]="selectionMode"
        [sortStrategy]="noopSortStrategy" (columnInit)="onColumnInit($event)"
        (rowSelectionChanging)="onSelectRow($event)" (toolbarExporting)="onToolbarExporting($event)"
        (filteringExpressionsTreeChange)="onFilterChange($event)" (sortingExpressionsChange)="onSortingChange($event)"
        [class]="gridClasses">

        @if (allowMultipleSelection; as context) {
        <ng-template igxHeadSelector let-context>
            <div class="header-selector">
                <igx-checkbox [checked]="areAllSelected(context.selectedCount)"
                    (click)="onSelectHeader($event, context.selectedCount)"
                    [indeterminate]="context.selectedCount !== 0 && !this.areAllSelected(context.selectedCount)">
                </igx-checkbox>
            </div>
        </ng-template>
        }

        <ng-template igxRowSelector let-rowContext>
            <div class="row-selector">
                <!-- TODO - move this ariaLabel logic behind a method -->
                <igx-checkbox [checked]="rowContext.selected" [readonly]="true"
                    [aria-label]="rowContext.selected ? 'Deselect row' : 'Select row'">
                </igx-checkbox>
            </div>
        </ng-template>

        <igx-column field="Id" [filterable]="false" header="Id" [hidden]="true">
        </igx-column>

        @for (column of columns; track column) {
        <igx-column [additionalTemplateContext]="column" [dataType]="column.dataType" [editable]="false"
            [field]="column.name" [filterable]="column.isFilterable" [formatter]="getColumnFormatter(column)"
            [hasSummary]="hasSummary(column)" [header]="column.label" [hidden]="isColumnHidden(column)"
            [resizable]="true" [sortable]="allowSort" [summaries]="getSummaryOperand(column)"
            [summaryFormatter]="getSummaryFormatter()" [width]="getColumnWidth(column)">
            <ng-template igxHeader let-column>
                {{column.header}}
                <forge-tooltip placement="bottom">
                    {{column.header}} | ({{column.dataType}})
                </forge-tooltip>
            </ng-template>
        </igx-column>
        }

        <ng-template igxExcelStyleHeaderIcon>
            <igx-icon style="font-size: 0.9375rem; height: 0.9375rem;">filter_alt</igx-icon>
        </ng-template>

        <igx-grid-excel-style-filtering maxHeight="288px" minHeight="288px">
            <igx-excel-style-filter-operations>
                <igx-excel-style-clear-filters (click)="clearQuickFilter()">
                </igx-excel-style-clear-filters>

                <igx-excel-style-conditional-filter>
                </igx-excel-style-conditional-filter>
            </igx-excel-style-filter-operations>
        </igx-grid-excel-style-filtering>

        <igx-action-strip #actionStrip>
            <grid-row-actions [strip]="actionStrip" [datacontroller]="datacontroller"
                [disableViewAction]="disableViewAction" [providerId]="providerId" [infoTable]="infoTable"
                [isSearchTable]="isSearchTable" (customAction)="doRowAction($event)"
                (customCommand)="doCustomCommand($event)" (editRow)="onEditRow($event)"
                (deleteRow)="onDeleteRow($event)" (reloadTableData)="onReloadTableData($event)">
            </grid-row-actions>
        </igx-action-strip>

        <igx-grid-toolbar #toolbar>
            <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between center">
                <!-- TODO - why didn't we want to use the IgxGridToolBarTitle Component? -->
                @if (showTitle) {
                <div class="forge-typography--heading2">
                    {{title}}
                </div>
                }

                <span fxFlex="auto"></span>

                <div fxLayout="row" fxLayoutAlign="end center">

                    @if (!standAlone) {
                    <!-- TODO - convert to command -->
                    <forge-icon-button (click)="toggleTableOptions()" aria-label="Toggle table options">
                        <forge-tooltip placement="bottom">
                            <span>
                                <!-- TODO - move this text to behind a property  -->
                                {{ tableOptionsOpen ? 'Hide' : 'Show' }} table options
                            </span>
                        </forge-tooltip>
                        <forge-open-icon [open]="!tableOptionsOpen" orientation="horizontal">
                        </forge-open-icon>
                    </forge-icon-button>
                    <forge-expansion-panel [open]="tableOptionsOpen" orientation="horizontal">
                        <div fxLayout="row" fxLayoutAlign="end center" class="table-options toolbar-icon-container">
                            <div class="toolbar-icon-container--action">
                                <forge-tooltip placement="bottom">Hide columns</forge-tooltip>
                                <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
                                <!-- TODO - this ngIf is causing a ExpressionChangedAfterItHasBeenCheckedError -->
                                @if (grid.hiddenColumnsCount > 0) {
                                <forge-badge dot positioned strong>
                                </forge-badge>
                                }
                            </div>
                            <div class="toolbar-icon-container--action">
                                <forge-tooltip placement="bottom">Pin columns</forge-tooltip>
                                <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
                                @if (grid.pinnedColumnsCount > 0) {
                                <forge-badge dot positioned strong>
                                </forge-badge>
                                }
                            </div>
                            <div class="toolbar-icon-container--action">
                                <forge-tooltip placement="bottom">Export</forge-tooltip>
                                <igx-grid-toolbar-exporter #toolbarExporter></igx-grid-toolbar-exporter>
                            </div>
                            @if (enableLayout) {
                            <forge-icon-button class="button" [igxDropDownItemNavigation]="gridLayoutDropdown"
                                [igxToggleAction]="gridLayoutDropdown">
                                <forge-tooltip placement="bottom">Layout options</forge-tooltip>
                                <forge-icon name="grid_view"></forge-icon>
                            </forge-icon-button>
                            }
                            <igx-drop-down #gridLayoutDropdown>
                                <div class="dropdown-item-container">
                                    <igx-drop-down-item *igxFor="let item of layoutOptions; index as index;"
                                        (click)='onLayoutSelectionChanging($event)' igxRipple [index]="index"
                                        [value]="item.value">
                                        <span>{{ item.label }}</span>
                                    </igx-drop-down-item>
                                </div>
                            </igx-drop-down>
                        </div>
                    </forge-expansion-panel>
                    }

                    @if (hasTableCommands) {
                    <command-bar [commands]="customTableCommands">
                    </command-bar>
                    }

                    @if (isSearchTable) {
                    <div class="toolbar-icon-container">
                        @if (hasSearchCommands) {
                        <command-menu icon="more_vert" position="target-right bottom" [commands]="searchCommands"
                            aria-label="3Dot-Search">
                        </command-menu>
                        }
                    </div>
                    }

                    <!-- TODO - convert to command -->
                    @if (canAdd) {
                    <forge-button variant="raised" [disabled]="isViewOnly" (click)="addItem()" aria-label="Add">
                        <forge-icon name="add"></forge-icon>
                        <span>Add</span>
                    </forge-button>
                    }

                    @if (hasCommandMenu) {
                    <command-menu icon="more_vert" [commands]="tableCommands" position="target-right bottom"
                        telemetry="Menu-InfoTable">
                    </command-menu>
                    }

                    @if (hasCommandBar) {
                    <command-bar [commands]="tableCommands" telemetry="Menu-InfoTableMenuBar">
                    </command-bar>
                    }
                </div>
            </div>
        </igx-grid-toolbar>

        <igx-paginator [perPage]="perPage" [page]="currentPage">
            <igx-paginator-content fxLayoutAlign="end">
                <!-- TODO - convert ngClass value to property/method -->
                <forge-paginator [pageIndex]="currentPage" [pageSize]="perPage" [pageSizeOptions]="selectOptions"
                    [total]="totalRecords" [ngClass]="{'space-for-fab': spaceForFab}"
                    (forge-paginator-change)="onPageChange($event)">
                </forge-paginator>
            </igx-paginator-content>
        </igx-paginator>
    </igx-grid>
</forge-card>

<ng-template #booleanTemplate let-value>
    <div class="booleanIcon">
        @if (value) {
        <forge-icon name="check" class="grid-icon">
        </forge-icon>
        }
    </div>
</ng-template>

<!-- ! TODO - Nothing on the back-end ever uses this functionality. -->
<ng-template #iconTemplate let-column="additionalTemplateContext" let-cell="cell" let-value>
    <div class="igx-grid__td-text">
        @if (!useIconSpan(cell)) {
        <mat-icon [matTooltip]="value">
            {{getIcon(cell)}}
        </mat-icon>
        }

        @if (useIconSpan(cell)) {
        <span [ngClass]="getIcon(cell)" class="tt-icon">
        </span>
        }
    </div>
</ng-template>

<!-- ! TODO - Nothing on the back-end ever uses this functionality. -->
<ng-template #chipTemplate let-column="additionalTemplateContext" let-value>
    <div class="igx-grid__td-text">
        <mat-chip-listbox class="layout-row align-text-left paddingTop8">
            <mat-chip-option class="align-text-left">
                {{value}}
            </mat-chip-option>
        </mat-chip-listbox>
    </div>
</ng-template>